import { EntityUpgrades, UnitType, UpgradeStatus, UpgradeType } from '../../../types/game-types';

export const upgrades: Partial<EntityUpgrades> = {
  magicMissile: {
    id: UpgradeType.MagicMissile,
    icon: ['s_missile', 'plus1'],
    cost: { gold: 175 },
    costGrowthRate: 1.5,
    multiplier: 1,
    purchased: 0,
    bonusPerOwned: 0.05,
    purchaseLimit: 20,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  manaSword: {
    id: UpgradeType.ManaSword,
    icon: ['sword2', 's_potionFull'],
    cost: { gold: 10000 },
    costGrowthRate: 2.1,
    multiplier: 1,
    purchased: 0,
    bonusPerOwned: 0.1,
    purchaseLimit: 40,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  magicMouse: {
    id: UpgradeType.MagicMouse,
    icon: ['u_potionEmpty', 'd_s_cursor2'],
    cost: { gold: 200 },
    costGrowthRate: 1.3,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 0.05,
    isUnlocked: false,
    purchaseLimit: 100,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  manaSurge: {
    id: UpgradeType.ManaSurge,
    icon: ['u_s_potionFull', 'arrowUp1'],
    cost: { gold: 50 },
    costGrowthRate: 1,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 0,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
    status: UpgradeStatus.Unlocked,
  },
  manaPool: {
    id: UpgradeType.ManaPool,
    icon: ['u_potionFull', 'arrowUp2'],
    cost: { gold: 1000 },
    costGrowthRate: 1.9,
    multiplier: 100,
    purchased: 0,
    bonusPerOwned: 5,
    purchaseLimit: 60,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  manaBoost: {
    id: UpgradeType.ManaBoost,
    icon: ['u_potionHalf', 'staff1'],
    cost: { gold: 125 },
    costGrowthRate: 3,
    multiplier: 100,
    purchased: 0,
    bonusPerOwned: -2,
    isUnlocked: false,
    purchaseLimit: 25,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  silverStaff: {
    id: UpgradeType.SilverStaff,
    icon: ['silverBar', 'staff2'],
    cost: { gold: 400 },
    costGrowthRate: 1.5,
    multiplier: 1,
    purchased: 0,
    bonusPerOwned: 0.1,
    purchaseLimit: 40,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  goldenStaff: {
    id: UpgradeType.GoldenStaff,
    icon: ['goldBar', 'staff2'],
    cost: { gold: 6000 },
    costGrowthRate: 1.95,
    multiplier: 1,
    purchased: 0,
    bonusPerOwned: 0.5,
    purchaseLimit: 40,
    isUnlocked: false,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  archimage: {
    id: UpgradeType.Archimage,
    icon: ['staff3'],
    cost: { gold: 9000 },
    costGrowthRate: 3.1,
    multiplier: 0,
    purchased: 0,
    bonusPerOwned: 0.05,
    purchaseLimit: 80,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'generators',
  },
  weatherForecast: {
    id: UpgradeType.WeatherForecast,
    icon: ['u_cloud'],
    cost: { gold: 1000 },
    costGrowthRate: 3,
    multiplier: 0,
    purchased: 0,
    purchaseLimit: 25,
    bonusPerOwned: 1,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'click',
  },
  lightningStrike: {
    id: UpgradeType.LightningStrike,
    icon: ['lightning'],
    cost: { gold: 4500 },
    costGrowthRate: 3,
    multiplier: 1,
    purchased: 0,
    purchaseLimit: 10,
    bonusPerOwned: 0.5,
    isUnlocked: false,
    isLockedOnDemo: true,
    type: UnitType.UPGRADE,
    tier: 'click',
  },
};
